<template>
  <div
    class="modal-w d-grid position-fixed top-0 start-0 h-100 w-100"
    v-if="modal"
  >
    <div class="modal-p position-relative p-4 pt-5" v-if="modal">
      <div @click="modal = false" role="button" class="btn-close position-absolute"></div>

      <row-component>
        <col-component
          v-for="(data, index) in photos"
          :key="index"
          class-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 px-3"
        >
          <div class="card rounded-0">
            <img class="img-fluid" v-if="data.photo" :src="data.photo" alt="" />
            <div class="btn-group" role="group" aria-label="Basic example">
              <button-submit
                @click="updateGrossProductPhotoCover(data.id)"
                icon="check"
                name="Selecionar"
              />
            </div>
          </div>
        </col-component>
      </row-component>
    </div>
  </div>

  <painel-component :items="itemsOne">
    <error-component :errors="errors" v-if="showError" />

    <div class="tabs effect-3" v-if="viewPage">
      <input type="radio" id="tab-1" name="tab-effect-3" checked />
      <span>
        <i class="info circle icon"></i>
        <span>Informações</span>
      </span>

      <input type="radio" id="tab-2" name="tab-effect-3" />
      <span>
        <i class="camera icon"></i>
        <span>Foto</span>
      </span>

      <div class="line ease"></div>
      <div class="tab-content">
        <section id="tab-item-1">
          <form>
            <row-component>
              <col-component
                class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.name }"
              >
                <label>Nome:</label>
                <input-component v-model="formData.name" />
              </col-component>

              <col-component
                class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.name }"
              >
                <label>Referência:</label>
                <input-component disabled v-model="formData.code" />
              </col-component>

              <col-component
                class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.status }"
              >
                <label>Status:</label>
                <MultiSelect v-model="formData.status" :options="selectActiveInative" />
              </col-component>
            </row-component>

            <row-component>
              <col-component
                class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.minimum_stock_store }"
              >
                <label>Estoque mínimo:</label>
                <input-component v-model="formData.minimum_stock_store" type="number" />
              </col-component>

              <col-component
                class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.initial_inventory_store }"
              >
                <label>Estoque:</label>
                <input-component v-model="formData.initial_inventory_store" type="number" />
              </col-component>

              <col-component
                class-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.kilo }"
              >
                <label>Peso:</label>
                <div class="position-relative">
                  <p
                    class="position-absolute top-50 start-0 translate-middle-y"
                    style="margin-left: 10px"
                  >
                    {{ formData.kilo }}
                  </p>
                  <input-component
                    autocomplete="off"
                    type="number"
                    id="kilos"
                    @keyup="funcOne"
                    style="color: #ffffff !important"
                  />
                </div>
              </col-component>

              <col-component class-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12"
                             :class="{'formError' : errors.cost_price}">
                <label>Preço custo:</label>
                <input-component v-model="formData.cost_price" v-money="MONEY"/>
              </col-component>

              <col-component
                class-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.price }"
              >
                <label>Preço Venda:</label>
                <input-component v-model="formData.price" v-money="MONEY" />
              </col-component>
            </row-component>

            <row-component>
              <col-component
                class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.category_id }"
              >
                <label>Categoria:</label>
                <MultiSelect v-model="formData.category_id" :options="selectCategory" />
              </col-component>

              <col-component
                class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.subcategory_id }"
              >
                <label>Subcategoria:</label>
                <MultiSelect v-model="formData.subcategory_id" :options="selectSubcategory" />
              </col-component>

              <col-component
                class-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.height }"
              >
                <label>Altura (cm):</label>
                <input-component v-money="centimeters" v-model="formData.height" />
              </col-component>

              <col-component
                class-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.width }"
              >
                <label>Largura (cm):</label>
                <input-component v-money="centimeters" v-model="formData.width" />
              </col-component>

              <col-component
                class-col="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.length }"
              >
                <label>Comprimento (cm):</label>
                <input-component v-money="centimeters" v-model="formData.length" />
              </col-component>
            </row-component>

            <row-component>
              <col-component
                class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.sector }"
              >
                <label>Setor:</label>
                <input-component v-model="formData.sector" />
              </col-component>

              <col-component
                class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.column }"
              >
                <label>Coluna:</label>
                <input-component v-model="formData.column" type="number" />
              </col-component>

              <col-component
                class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.shelf }"
              >
                <label>Prateleira:</label>
                <input-component v-model="formData.shelf" type="number" />
              </col-component>
            </row-component>

            <row-component>
              <col-component
                class-col="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                :class="{ formError: errors.desc }"
              >
                <label>Descrição:</label>
                <text-area v-model="formData.desc" rows="6" />
              </col-component>
            </row-component>

            <row-component>
              <col-component class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <button-route class="w-100" :items="itemsTwo" />
              </col-component>

              <col-component class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <button-submit
                  :disabled="sendForm"
                  @click="submit"
                  class="w-100"
                  icon="save"
                  name="Salvar"
                />
              </col-component>
            </row-component>
          </form>
        </section>

        <section id="tab-item-2">
          <div class="clearfix mb-3">
            <button-submit
              @click="openModal"
              name="Selecionar capa"
              v-if="formData.photos.length > 0"
            />

            <label class="btn-label btn" for="files" v-if="!cropper">
              <i class="m-0 icon plus"></i>
              <input id="files" @change="onFileChange" class="d-none" type="file" />
            </label>

            <button-submit
              @click="updateGrossProductPhoto"
              v-else-if="this.photo_id !== ''"
              class="float-end"
              icon="save"
            />
            <button-submit @click="onChange" v-else class="float-end" icon="save" />

            <button-submit
              v-if="cropper"
              @click="cropper = false"
              class="float-end me-2"
              icon="close"
            />
          </div>

          <div v-if="cropper" style="width: 400px; display: block; margin: 0 auto; height: 400px" >
            <cropper ref="cropper" class="me-3" :src="photoCropper" :stencil-props="{aspectRatio: 1/1}"/>
          </div>

          <br><br>
          <div
            class="alert alert-secondary alert-dismissible fade show"
            role="alert"
            v-if="formData.photos.length === 0"
          >
            <p>Não há nada cadastrado</p>
          </div>

          <div class="draggable" v-else>
            <draggable v-model="formData.photos" @start="drag = true" @end="onEnd" item-key="id">
              <template #item="{ element, index }">
                <col-component
                  class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 px-3"
                >
                  <div
                    class="card rounded-0 border-2"
                    :class="{ 'border-black': parseInt(element.cover) === 2 }"
                  >
                    <img class="img-fluid" v-if="element.photo" :src="element.photo" alt="" />
                    <div class="btn-group" role="group" aria-label="Basic example">
                      <label
                        @click="getPhotoID(element.id)"
                        class="btn-label btn"
                        :for="'files' + index"
                        v-if="!cropper"
                      >
                        <i class="m-0 icon edit"></i>
                        <input
                          :id="'files' + index"
                          @change="onFileChange"
                          class="d-none"
                          type="file"
                        />
                      </label>
                      <button-delete @click="destroyGrossProductPhoto(element.id)" />
                    </div>
                  </div>
                </col-component>
              </template>
            </draggable>
          </div>
        </section>
      </div>
    </div>
  </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import ColComponent from '@/components/row/ColComponent';
import InputComponent from '@/components/form/InputComponent';
import MultiSelect from '@/components/form/MultiSelect';
import TextArea from '@/components/form/TextArea';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import ButtonDelete from '@/components/buttons/ButtonDelete';
import ErrorComponent from '@/components/alerts/ErrorComponent';
import draggable from 'vuedraggable';

import swal from 'sweetalert';
import { VMoney } from 'v-money';
import { MONEY } from '@/configs/constants';
import { useToast } from 'vue-toastification';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import { ref } from 'vue';

const toast = useToast();
export default {
  name: 'GrossProductUpdate',

  components: {
    draggable,
    Cropper,
    ErrorComponent,
    ButtonDelete,
    ButtonRoute,
    ButtonSubmit,
    TextArea,
    MultiSelect,
    InputComponent,
    ColComponent,
    RowComponent,
    PainelComponent
  },

  directives: {
    money: VMoney
  },

  props: {
    id: {
      required: true
    }
  },

  created() {
    this.$store.dispatch('changeNamePage', 'Produto Bruto');
    this.$store.dispatch('loadSelectCategory');
    this.$store.dispatch('loadSelectSubcategory');
    this.loadItems();
    this.checkACL();
  },

  data() {
    return {
      itemsOne: {
        title: 'Editar',
        icon: 'edit'
      },

      itemsTwo: {
        route: '/gross-product/search',
        icon: 'reply all',
        name: 'Voltar'
      },

      formData: {
        name: '',
        status: '',
        cost_price: '',
        price: '',
        code: '',
        minimum_stock_store: '',
        initial_inventory_store: '',
        category_id: '',
        subcategory_id: '',
        kilo: '',
        height: '',
        width: '',
        length: '',
        sector: '',
        shelf: '',
        column: '',
        desc: '',
        photos: []
      },

      MONEY,

      centimeters: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },

      photo: '',
      photo_id: '',
      photoCropper: '',
      cropper: false,
      imagePreview: '',

      drag: false,

      photos: '',
      modal: false,

      errors: [],
      viewPage: false,
      sendForm: false,
      showError: false
    };
  },

  methods: {
    loadItems() {
      this.$store
        .dispatch('loadGrossProduct', this.id)
        .then(r => {
          this.formData = { ...this.formData, ...r, photos: r.photos || [] };
        })
        .catch(() => {
          toast.error('Erro desconhecido!', { timeout: 1500 });
        });
    },

    submit() {
      if (!this.sendForm) {
        this.sendForm = true;
        this.$store
          .dispatch('updateGrossProduct', this.formData)
          .then(() => {
            this.showError = false;
            this.sendForm = false;
            this.errors = [];
            toast.success('Cadastro atualizado com sucesso', { timeout: 1500 });
            window.scroll(0, 0);
          })
          .catch(e => {
            this.showError = true;
            this.sendForm = false;
            window.scroll(0, 0);
            this.errors = e.response.data.errors;
          });
      }
    },

    funcOne(event) {
      let value = event.target.value;
      value = parseInt(0 + value);
      return (this.formData.kilo = this.kiloMask(this.pad(value, 5)));
    },

    kiloMask(v) {
      v = v.replace(/^(\d{3})(\d{1})/, '$1,$2');
      return v;
    },

    pad(str, max) {
      str = str.toString();
      str = str.length < max ? this.pad('0' + str, max) : str;
      str = str.length > max ? str.substring(0, max) : str;
      return str;
    },

    async checkACL() {
      this.$store
        .dispatch('ACLItems', 8)
        .then(r => {
          if (r.indexOf('gross-product-edit') !== -1) {
            this.viewPage = true;
          } else {
            this.$router.push({ name: 'home' });
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' });
        });
    },

    openModal() {
      this.$store
        .dispatch('loadGrossProductPhotos', this.id)
        .then(response => {
          this.photos = response;
          this.modal = true;
        })
        .catch(() => {
          toast.error('Erro desconhecido');
        });
    },

    onEnd() {
      this.drag = false;
      let photos = this.formData.photos;
      let formData = { id: this.id, photos_ordem: [] };

      photos.forEach((element, index) => {
        formData.photos_ordem.push({
          id: element.id,
          order: index
        });
      });
      this.$store.dispatch('updateGrossProductPhotoOrder', formData);
    },

    onChange() {
      const { canvas } = this.$refs.cropper.getResult();
      canvas.toBlob(
        blob => {
          this.photo = blob;
        },
        'image/png',
        '0.95'
      );
      setTimeout(() => {
        this.storeGrossProductPhoto();
        this.$refs.cropper = ref(null);
      }, 500);
    },

    getPhotoID(id) {
      this.photo_id = id;
    },

    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.photo = files[0];
      if (files[0].type.indexOf('image') === 0) {
        this.previewImage(files[0]);
      }
      this.cropper = true;
    },

    previewImage(file) {
      let reader = new FileReader();
      reader.onload = e => {
        this.photoCropper = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    storeGrossProductPhoto() {
      let formData = { id: this.id, photo: this.photo };
      this.$store
        .dispatch('storeGrossProductPhoto', formData)
        .then(() => {
          this.errors = [];
          this.showError = false;
          this.cropper = false;
          this.loadItems();
          toast.success('Foto adicionada com sucesso', { timeout: 2000 });
        })
        .catch(e => {
          this.showError = true;
          this.errors = e.response.data.errors;
          window.scroll(0, 0);
        });
    },

    updateGrossProductPhoto() {
      let formData = { id: this.id, photo_id: this.photo_id, photo: this.photo };
      this.$store
        .dispatch('updateGrossProductPhoto', formData)
        .then(() => {
          this.errors = [];
          this.showError = false;
          this.cropper = false;
          this.photo_id = '';
          this.loadItems();
          toast.success('Foto atualizada com sucesso', { timeout: 2000 });
        })
        .catch(e => {
          this.showError = true;
          this.errors = e.response.data.errors;
          window.scroll(0, 0);
        });
    },

    destroyGrossProductPhoto(id) {
      swal({
        title: 'Atenção!',
        text: `Deseja realmente deletar esta foto?`,
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: 'Não',
            visible: true,
            closeModal: true
          },
          confirm: 'Sim'
        }
      }).then(result => {
        let formData = { id: parseInt(this.id), photo_id: id };
        if (result) {
          this.$store
            .dispatch('destroyGrossProductPhoto', formData)
            .then(() => {
              this.loadItems();
              toast.success('Foto deletado com sucesso', { timeout: 1500 });
            })
            .catch(() => {
              toast.error(`Não foi possível deletar`, { timeout: 1500 });
            });
        }
      });
    },

    updateGrossProductPhotoCover(id) {
      let formData = { id: this.id, photo_id: id };
      this.$store
        .dispatch('updateGrossProductPhotoCover', formData)
        .then(() => {
          this.errors = [];
          this.showError = false;
          this.cropper = false;
          this.modal = false;
          this.loadItems();
          toast.success('Foto atualizada com sucesso', { timeout: 2000 });
        })
        .catch(e => {
          this.showError = true;
          this.errors = e.response.data.errors;
          window.scroll(0, 0);
        });
    }
  },

  computed: {
    selectActiveInative() {
      return this.$store.state.var.selectActiveInative;
    },

    selectCategory() {
      return this.$store.state.var.selectCategory;
    },

    selectSubcategory() {
      return this.$store.state.var.selectSubcategory;
    }
  }
};
</script>

<style scoped>
.modal-w {
  z-index: 99;
  place-items: center;
  background-color: rgba(0, 0, 0, 0.7);
}

.modal-p {
  width: 80%;
  overflow-y: auto;
  min-height: 800px;
  background-color: #ffffff;
}

.modal-p .btn-close {
  top: 10px;
  right: 10px;
}

.tabs > input,
.tabs > span,
.effect-3 .line {
  width: 50%;
}

#tab-2,
#tab-2 + span,
#tab-2:checked ~ .line {
  left: 50%;
}

.btn-label {
  float: right;
  color: #ffffff;
  border-radius: 0;
  border-color: #000000;
  background-color: #000000;
}

.btn-label:active,
.btn-label:focus,
.btn-label:hover {
  color: #ffffff;
  border-color: #000000 !important;
  background-color: #000000 !important;
}

.draggable > div {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
</style>
